import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCheckup from './store/checkup.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CheckupEffects } from './store/checkup.effects';
import { CheckupFeatureComponent } from './features/checkup-feature.component';
import { CheckupPresenterComponent } from './presenters/checkup-presenter.component';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
    declarations: [CheckupFeatureComponent, CheckupPresenterComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        StoreModule.forFeature(
            fromCheckup.checkupsFeatureKey,
            fromCheckup.reducer
        ),
        EffectsModule.forFeature([CheckupEffects])
    ]
})
export class CheckupModule {}
